import { ChakraProvider } from '@chakra-ui/react';

import { AppProvider } from '@cccom/config/app-config';
import { homeTheme } from '@cccom/shared/themes';

import { environment } from '../env';
import { router } from './Routes';

function App() {
  return (
    <ChakraProvider theme={homeTheme}>
      <AppProvider environment={environment} routerProps={{ router }} />
    </ChakraProvider>
  );
}

export default App;
